<template>
  <div class="contents yuukyuu-kanri-list">

    <scroll-table>
      <template v-if="isLoading">
        <loading :isLoading="isLoading" :message="'読み込み中...'"></loading>
      </template>
      <table v-if="!isLoading">
        <thead>
          <tr>
            <th>社員番号</th>
            <th>氏名</th>
            <th>部課</th>
            <th>入社年</th>
            <!-- <th>前年度<br />繰越日数</th> -->
            <!-- <th>特別有給</th> -->
            <!-- <th>今年度<br />付与日数</th> -->
            <th>合計有給<br />日数</th>
            <!-- <th>繰越分<br />使用日数</th> -->
            <!-- <th>今年度分<br />使用日数</th> -->
            <th>合計有給<br />使用日数</th>
            <th>有給残</th>
            <!-- <th>締日</th> -->
            <th>基準日<br />有給付与日</th>
            <th>有給消化<br />期限日</th>
            <th>期限日まで<br />（満何か月残ってるか）</th>
            <th>法定義務の<br />うちの未消化日数</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in list">
            <template v-if="list.length > 0">
              <tr :key="index">
                <td>{{ item.staff_code }}</td>
                <td><router-link :to="{
                    name: RouterConst.YUUKYUU_KANRI_DETAIL,
                    params: { code: item.user_id },
                  }">{{ item.staff_name }}</router-link></td>
                <td>{{ item.syuugyou_basyo_name }}</td>
                <td>{{ dateFormat(item.nyuusya_date) }}</td>
                <!-- <td>{{ item.last_year_kurikoshi_days_not_in_tokubetu }}</td> -->
                <!-- <td>{{ item.this_year_tokubetu_yuukyuu_days }}</td> -->
                <!-- <td>{{ item.this_year_fuyo_days }}</td> -->
                <td>{{ item.total_fuyo_days }}</td>
                <!-- <td>{{ item.kurikoshi_use_days }}</td> -->
                <!-- <td>{{ item.this_year_use_days }}</td> -->
                <td>{{ item.total_use_days }}</td>
                <td>{{ item.zan_days }}</td>
                <!-- <td>{{ item.shime_day_str }}</td> -->
                <td>{{ dateFormat(item.this_year_fuyo_date) }}</td>
                <td>{{ dateFormat(item.use_kigen_date) }}</td>
                <td>{{ item.zan_month }}</td>
                <td>{{ item.misyouka_days }}</td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </scroll-table>
    <!--button-container-->
  </div>
  <!--contents-->
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouterConst } from "@/const/Router";
import { dateFormat } from '@/filters/common';
import { KanriDaichouListData } from "@/types/YuukyuuKanri";

export default defineComponent({
  props: {
    list: {
      type: Object as () => KanriDaichouListData[],
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  setup(props) {
    const decimalFormat = (val: number) => {
      return val ? val.toFixed(1) : val
    }

    return {
      props,
      RouterConst,
      dateFormat,
      decimalFormat,
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/yuukyuu-list.scss';
</style>